import React, { useContext, useEffect, useState } from "react";
import {
    Avatar,
    Box,
    Button,
    Container,
    Link as LinkMui,
    Grid,
    TextField,
    Typography,
    Alert,
} from "@mui/material";
import { Link } from "react-router-dom";
import { AuthContext } from "../../context/auth-provider";
import { styled } from "@mui/material/styles";
import { axiosInstancePublic } from "../../services/axios-instance";
import { GOOGLE_AUTH } from "../../services/endpoints";
import axios from "axios";

const GoogleBTNDiv = styled("a")(({ theme }) => ({
    borderRadius: 4,
    marginTop: 16,
    marginBottom: 8,
    border: '1px solid lightgrey',
    width: '100%',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    fontSize: '1.2rem',
    color: theme.palette.primary.main,
    cursor: 'pointer',

    '& p': {
        backgroundColor: theme.palette.common.white,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        fontSize: '1.2rem',
        color: theme.palette.primary.main,
        padding: 12,
        cursor: 'pointer',
    },
    '& img': {
        width: 28,
        height: 28,
    },
}));

function Copyright(props: any) {
    return (
        <Typography
            variant="body2"
            color="text.secondary"
            align="center"
            {...props}
        >
            {"Copyright © "}
            <LinkMui color="inherit" href="https://xgate.io/">
                X-Gate NEW
            </LinkMui>{" "}
            {new Date().getFullYear()}
            {"."}
        </Typography>
    );
}

const LogIn = () => {
    const [email, setEmail] = useState("");
    const [pwd, setPwd] = useState("");
    const [loginUrl, setLoginUrl] = useState("/");
    const [error, setError] = useState<{
        email?: string[];
        password?: string[];
        general?: string[];
    }>({});

    const { login } = useContext(AuthContext);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setError({});

        try {
            await login(email, pwd);
        } catch (error: any) {
            if (axios.isAxiosError(error) && error.response) {
                const status = error.response.status;
                const errorData = error.response.data.message;

                if (status === 400) {
                    setError(errorData);
                } else if (status === 401 || status === 403) {
                    setError({
                        general: [errorData],
                    });
                } else {
                    setError(errorData);
                }
            } else {
                setError({
                    general: [
                        "Network error: Please check your internet connection.",
                    ],
                });
            }
        }
    };

    useEffect(() => {
        const loginWithGoogle = async () => {
            try {
                const response = await axiosInstancePublic.get(GOOGLE_AUTH);
                if (response.data.url) {
                    setLoginUrl(response.data.url);
                } else {
                    throw new Error("Something went wrong!");
                }
            } catch (error) {
                console.error(error);
            }
        };

        loginWithGoogle();
    }, []);

    return (
        <Container component="main" maxWidth="xs">
            <Box
                sx={{
                    marginTop: 8,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                }}
            >
                <Avatar
                    src="/logo.svg"
                    variant="square"
                    alt="logo"
                    sx={{ mb: 0.5 }}
                />
                <Typography component="h1" variant="h5">
                    Log in
                </Typography>
                {error.email && (
                    <Alert severity="error" sx={{ width: "100%", mt: 2 }}>
                        {error.email.map((errMsg, index) => (
                            <div key={index}>{errMsg}</div>
                        ))}
                    </Alert>
                )}
                {error.password && (
                    <Alert severity="error" sx={{ width: "100%", mt: 2 }}>
                        {error.password.map((errMsg, index) => (
                            <div key={index}>{errMsg}</div>
                        ))}
                    </Alert>
                )}
                {error.general && (
                    <Alert severity="error" sx={{ width: "100%", mt: 2 }}>
                        {error.general.map((errMsg, index) => (
                            <div key={index}>{errMsg}</div>
                        ))}
                    </Alert>
                )}
                <Box component="form" onSubmit={handleSubmit} noValidate>
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        id="name"
                        label="Email"
                        name="name"
                        autoComplete="name"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <TextField
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        type="password"
                        id="password"
                        autoComplete="current-password"
                        value={pwd}
                        onChange={(e) => setPwd(e.target.value)}
                    />
                    <div style={{ marginTop: "1rem" }}>
                        <div>
                            <GoogleBTNDiv
                                href={loginUrl !== "/" ? loginUrl : undefined}
                            >
                                <p>
                                    Log in with Google
                                    <img
                                        src="/googleLogo.svg"
                                        alt="googleLogo"
                                    />
                                </p>
                            </GoogleBTNDiv>
                        </div>
                    </div>

                    <Button
                        type="submit"
                        color="info"
                        fullWidth
                        variant="contained"
                        sx={{ mt: 2, mb: 2 }}
                        // onClick={() => login(email, pwd)}
                    >
                        Log In
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link
                                to="/forgot-password"
                                style={{ textDecoration: "none" }}
                            >
                                <Typography variant="body2" color="primary">
                                    Forgot password?
                                </Typography>
                            </Link>
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Copyright sx={{ mt: 4, mb: 4 }} />
        </Container>
    );
};

export default LogIn;
